import type { FetchOptions } from '@atlassian/jira-insights-common-constants/src/common/types/fetch.tsx';
import { fetchJson } from '@atlassian/jira-insights-fetch/src/services/fetch/fetch-json/index.tsx';
import { responseTypes } from '../../common/constants.tsx';
import type {
	ArisSprintCommitmentResponse,
	ArisSprintCommitmentResponseSuccess,
	ArisSprintCommitmentResponseRecalculating,
} from '../../common/types.tsx';
import { SprintCommitmentRecalculatingError } from '../recalculating-error/index.tsx';
import type { Parameters } from './types.tsx';

const buildUrl = (cloudId: string, rapidViewId: number, shouldUseJQLData: boolean): string =>
	`/gateway/api/aris/jira/${cloudId}/board/${rapidViewId}/sprint-commitment?useJQL=${shouldUseJQLData}`;

function isRecalculating(
	response: ArisSprintCommitmentResponse,
): response is ArisSprintCommitmentResponseRecalculating {
	return response.responseMeta.type === responseTypes.RECALCULATING;
}

export const fetchArisSprintCommitmentResponseSuccess = async (
	{ cloudId, rapidViewId, shouldUseJQLData }: Parameters,
	options?: FetchOptions,
): Promise<ArisSprintCommitmentResponseSuccess> => {
	const url = buildUrl(cloudId, rapidViewId, shouldUseJQLData);

	const response: ArisSprintCommitmentResponse = await fetchJson(url, options);

	if (isRecalculating(response)) {
		throw new SprintCommitmentRecalculatingError();
	}

	return response;
};
